export interface GeneratedProposalBlockWithIndex {
  block: GeneratedProposalBlock;
  index: number;
}

interface GeneratedProposalHeadingBlockWithIndex {
  block: GeneratedProposalHeadingBlock;
  index: number;
}

export interface GeneratedProposalBlockGroup {
  heading: GeneratedProposalHeadingBlockWithIndex | null;
  items: GeneratedProposalBlockWithIndex[];
}

export function groupGeneratedBlocks(
  blocks: GeneratedProposalBlock[],
): GeneratedProposalBlockGroup[] {
  const groups: GeneratedProposalBlockGroup[] = [];
  let currentGroup: GeneratedProposalBlockGroup | null = null;

  blocks.forEach((block, index) => {
    if (block.type === 'heading') {
      currentGroup = { heading: { block, index }, items: [] };
      groups.push(currentGroup);
      return;
    }

    if (!currentGroup) {
      currentGroup = { heading: null, items: [] };
      groups.push(currentGroup);
    }

    currentGroup.items.push({ block, index });
  });

  return groups;
}
